module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/classic-tee/13-cb4a60dfeef8632c849ff9aad4df0c04.jpg";